<template>
    <div class="py-5">
        <h2 class="mb-1">{{ $t('choose_marketplace') }}</h2>
    </div>
    <ul class="nav nav-tabs nav-pills flex-row me-5 mb-3 fs-6 second-tabs" id="second-tabs">
        <li v-for="(marketplace, index) in marketplaces_list" :key="marketplace.id" class="nav-item me-2 position-relative">
            <a :class="['nav-link marketplace-select-styles', { 'active': marketplace.id == firstMarketplace }, 'btn btn-active-primary-color bg-white text-secondary']"
                data-bs-toggle="tab" :href="`#marketplace_${marketplace.id}`">
                <img :class="`marketplace-${marketplace.id}`" :width="50" :height="50" :src="marketplace.logo_url"
                    :alt="marketplace.gateway_type">
                <span class="d-flex flex-column align-items-center">
                    <span class="fs-4 fw-bolder">{{ marketplace.name }}</span>
                </span>
            </a>
            <button class="remove-marketplace btn btn-bg-danger rounded text-white" type="button" @click="removeMarketplace(marketplace.id)">x</button>
        </li>
        <li class="nav-item me-2">
            <a class="nav-link marketplace-select-styles btn btn-active-parimary-color bg-white text-secondary"
                data-bs-toggle="modal" data-bs-target="#add_marketplaces">
                <i class="bi bi-plus-circle text-primary mb " style="font-size: 40px;margin-bottom: 7px;"></i>
                <span class="d-flex flex-column align-items-center">
                    <span class="fs-4 fw-bolder">{{ $t('add') }}</span>
                </span>
            </a>
        </li>
    </ul>

    <div class="tab-content" id="myTabContent3">
        <div v-for="(marketplace, marketplaceID) in marketplaces" :key="marketplaceID" :id="'marketplace_' + marketplaceID"
            class="tab-pane fade" :class="{ 'show active': marketplaceID == firstMarketplace }">
            <template v-if="marketplaceID == 6">

                <div class="pt-10 pb-3">
                    <h2 class="mb-1">{{ $t('main_information') }}</h2>
                </div>

                <div class="row py-3">
                    <div class="form-group mb-4 col-6">
                        <Textinput label="name" type="text" :name="'marketplaces[' + marketplaceID + '][linked_product][title:ar]'" :value="marketplace?.linked_product?.translations?.find(t => t.locale === 'ar')?.title" placeholder="name"></Textinput>
                    </div>
                </div>
                <div class="row py-3">
                    <div class="form-group mb-4 col-6">
                        <Textarea label="short_description" :value="marketplace?.linked_product?.translations?.find(t => t.locale === 'ar')?.short_description" :name="'marketplaces[' + marketplaceID + '][linked_product][short_description:ar]'"></Textarea>
                    </div>
                </div>
                <div class="row py-3" v-if="marketplaceID == 7">
                    <label for="linked_product_categories" class="form-label">{{ $t('categories') }}</label>
                    <Select2 :modelValue="marketplace?.linked_product?.categories"  id="linked_product_categories" :name="'marketplaces[' + marketplaceID + '][linked_product][categories][]'" :options="options" multiple :settings="{ multiple: true, closeOnSelect: false }"></Select2>
                </div>

            </template>

            <template v-if="marketplaceID != 1 && marketplaceID != 6 && marketplaceID != 8">

                <div class="pt-10 pb-3">
                    <h2 class="mb-1">{{ $t('main_information') }}</h2>
                </div>

                <div class="row py-3">
                    <div class="form-group mb-4 col-6">
                        <Textinput label="name_ar" type="text" :name="'marketplaces[' + marketplaceID + '][linked_product][title:ar]'" :value="marketplace?.linked_product?.translations?.find(t => t.locale === 'ar')?.title" placeholder="name_ar"></Textinput>
                    </div>
                    <div class="form-group mb-4 col-6">
                        <Textinput label="name_en" type="text" :name="'marketplaces[' + marketplaceID + '][linked_product][title:en]'" :value="marketplace?.linked_product?.translations?.find(t => t.locale === 'en')?.title" placeholder="name_en"></Textinput>
                    </div>
                </div>
                <div class="row py-3">
                    <div class="form-group mb-4 col-6">
                        <Textarea label="short_description_ar" :value="marketplace?.linked_product?.translations?.find(t => t.locale === 'ar')?.short_description" :name="'marketplaces[' + marketplaceID + '][linked_product][short_description:ar]'"></Textarea>
                    </div>
                    <div class="form-group mb-4 col-6">
                        <Textarea label="short_description_en" :value="marketplace?.linked_product?.translations?.find(t => t.locale === 'en')?.short_description" :name="'marketplaces[' + marketplaceID + '][linked_product][short_description:en]'"></Textarea>
                    </div>
                </div>
                <div class="row py-3" v-if="marketplaceID == 7">
                    <label for="linked_product_categories" class="form-label">{{ $t('categories') }}</label>
                    <Select2 :modelValue="marketplace?.linked_product?.categories"  id="linked_product_categories" :name="'marketplaces[' + marketplaceID + '][linked_product][categories][]'" :options="options" multiple :settings="{ multiple: true, closeOnSelect: false }"></Select2>
                </div>

            </template>
            <div :key="'marketplace_variant_table_' + marketplaceID" :id="'marketplaces_variant_table_' + marketplaceID">

                <div class="pt-10 pb-3">
                    <h2 class="mb-1">{{ $t('variants') }}</h2>
                </div>

                <div class="py-3 table-responsive" id="attributes_container">
                    <table class="table table-bordered px-2" id="variants_table">
                        <thead id="variants_table_header">
                            <tr class="bg-light" id="variants_table_header_row">
                                <th class="min-w-125px text-center">{{ $t('product') }}</th>
                                <th class="text-center min-w-150px">{{ $t('sku') }}</th>
                                <th class="text-center min-w-150px">{{ $t('quantity') }}</th>
                                <th class="text-center min-w-100px">{{ $t('sellingPrice')
                                }}</th>
                                <th class="text-center min-w-100px">{{
                                    $t('priceAfterDiscount') }}</th>
                                <th v-if="marketplaceID == 1" class="min-w-125px text-center">
                                    {{ $t('ASIN') }}
                                </th>

                                <th v-if="marketplaceID == 8" class="min-w-125px text-center">
                                    {{ $t('External Url') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody id="variants_table_body">
                            <tr v-for="(linked_variant, key) in marketplace.linked_variant" :key="key">
                                <td class="text-center">
                                    <p>{{ marketplace.linked_product?.title }}</p>
                                </td>
                                <td class="text-center">
                                    <p>{{ linked_variant[0].sku }}</p>
                                </td>
                                <td class="text-center">
                                    <p>{{ linked_variant[0].quantity }}</p>
                                </td>
                                <td class="text-center">
                                    <Textinput :hasLable="false" class="form-control text-center form-control-sm" type="number"  :name="'marketplaces[' + linked_variant[0].marketplace_id + '][linked_variant][' + linked_variant[0].variant_id + '][selling_price]'" :value="linked_variant[0].selling_price" @input="linked_variant[0].selling_price = $event; linked_variant[0].discounted_price = Math.min(linked_variant[0].discounted_price, $event)"></Textinput>
                                </td>
                                <td class="text-center">
                                    <Textinput :hasLable="false" class="form-control text-center form-control-sm" type="number"  :name="'marketplaces[' + linked_variant[0].marketplace_id + '][linked_variant][' + linked_variant[0].variant_id + '][discounted_price]'" :value="linked_variant[0].discounted_price" @input="linked_variant[0].discounted_price = $event; linked_variant[0].selling_price = Math.max(linked_variant[0].selling_price, $event)"></Textinput>
                                </td>
                                <td v-if="marketplaceID == 1" class="text-center">
                                    <Textinput :hasLable="false" class="form-control text-center form-control-sm" type="text"  :name="'marketplaces[' + linked_variant[0].marketplace_id + '][linked_variant][' + linked_variant[0].variant_id + '][identifier_value]'" :value="linked_variant[0].identifier_value"></Textinput>
                                    <input type="hidden" :name="'marketplaces[' + linked_variant[0].marketplace_id + '][linked_variant][' + linked_variant[0].variant_id + '][identifier_type]'" value="ASIN">
                                </td>

                                <td v-if="marketplaceID == 8" class="text-center">
                                    <Textinput :hasLable="false" class="form-control text-center form-control-sm" type="text"  :name="'marketplaces[' + linked_variant[0].marketplace_id + '][linked_variant][' + linked_variant[0].variant_id + '][external_link]'" :value="getCatalogProductLink(linked_variant)"></Textinput>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <button class="d-none" @click="handleUpdateMarketplaces()"></button>
      <add-marketplaces-to-products
        :url="url"
        @updateMarketplaces="handleUpdateMarketplaces"
        :marketplacesIds="marketplacesIds"
        :id="product"
      ></add-marketplaces-to-products>
</template>
<style>
.remove-marketplace {
    position: absolute;
    width: 35px;
    height: 35px;
    line-height: normal;
    padding: 0!important;
    right: 0;
    top: 0;
}
.remove-marketplace:hover {
    background-color: #dd0a3e;
    border-color: #dd0a3e;
}
</style>
<script>
import { ref, onMounted, computed, watchEffect  } from 'vue';

import Textarea  from '@/components/shared/inputs/TextareaInput.vue'
import Textinput from '@/components/shared/inputs/Textinput.vue'
import addMarketplacesToProducts from '@/components/sales-managment/modals/addMarketplacesToProducts.vue'
import Select2 from 'vue3-select2-component';
import axios from 'axios';
// import Select2 from 'vue3-select2-component';
export default {
    name: 'MarketplacesComponent',
    components: {
        Select2,
        Textarea,
        Textinput,
        addMarketplacesToProducts,
    },
    setup(props) {
        const marketplaces_list = ref([]);
        const marketplaces = ref([]);
        const options = ref([]);
            const firstMarketplace = ref(7);
        // const getLinkedProduct = async () => {
        //     try {
        //         // Using Axios with full configuration to include headers
        //         axios({
        //             method: 'get',
        //             url: `${props.url}/api/products/linked_product?product_id=${props.product}`,
        //             headers: {
        //                 locale: props.locale, // Dynamically setting the 'locale' header
        //             }
        //         }).then(res => {
        //             appendCheckboxes(res?.data?.result?.marketplaces_list);
        //             marketplaces_list.value = res?.data?.result?.marketplaces_list;
        //             marketplaces.value = res?.data?.result?.marketplaces;
        //             firstMarketplace.value = res?.data?.result?.marketplaces_list[0]?.id;
        //         });
        //     } catch (error) {
        //         console.log('errors', error);
        //     }
        // };

        const getLinkedProduct = async () => {
            try {
                // Using Axios with full configuration to include headers
                const response = await axios({
                    method: 'get',
                    url: `${props.url}/api/products/linked_product?product_id=${props.product}`,
                    headers: {
                        locale: props.locale, // Dynamically setting the 'locale' header
                    }
                });

                const checkAppendCheckboxes = () => {
                    return new Promise((resolve) => {
                        const interval = setInterval(() => {
                            if (typeof appendCheckboxes === 'function') {
                                clearInterval(interval); // Stop the interval once the function exists
                                resolve();
                            }
                        }, 100); // Check every 100ms
                    });
                };

                await checkAppendCheckboxes(); // Wait for appendCheckboxes to exist
                appendCheckboxes(response?.data?.result?.marketplaces_list);

                marketplaces_list.value = response?.data?.result?.marketplaces_list;
                marketplaces.value = response?.data?.result?.marketplaces;
                firstMarketplace.value = response?.data?.result?.marketplaces_list[0]?.id;

            } catch (error) {
                console.log('errors', error);
            }
        };


        const fetchOptions = async () => {
            try {
                const response = await axios.get(`${props.url.includes("api") ? props.url : (props.url  +'/api') }/linked_categories/list?page=1&marketplace_id=7`);

                // Filter options based on marketplacesIds
                options.value = response.data.result.list;
            } catch (error) {
                console.error(error);
            }
        };

        watchEffect(() => {
            fetchOptions();
        });
        const marketplacesIds = computed(() => {
            return marketplaces_list.value.map(marketplace => marketplace.id);
        });
        // const fetchZidCategories = async () => {
        //     try {
        //         const response = await axios.get('marketplaces/ajaxLinkedMarketplaces');

        //         // Filter options based on marketplacesIds
        //         options.value = response.data.results.filter(option => !marketplacesIds.value.includes(option.id));
        //     } catch (error) {
        //         console.error(error);
        //     }
        // };

        onMounted(() => {
            getLinkedProduct();
            // fetchZidCategories();
        });

        return {
            marketplaces,
            options,
            marketplacesIds,
            firstMarketplace,
            marketplaces_list
        };
    },
    props: {
        locale: null,
        url: null,
        product: null,
        product_link:null,
    },
    methods: {
        isFirst(index) {
            return index === 0;
        },
        getTitle(marketplace, locale_key) {
            // Logic to get the title
            return marketplace.linked_product?.translations[locale_key]?.title || '';
        },
        handleUpdateMarketplaces() {

            axios({
                method: 'get',
                url: `${this.url}/api/products/linked_product?product_id=${this.product}`,
                headers: {
                    locale: this.locale, // Dynamically setting the 'locale' header
                }
            }).then(res => {
                this.marketplaces_list = res?.data?.result?.marketplaces_list
                this.marketplaces = res?.data?.result?.marketplaces

                appendCheckboxes(res?.data?.result?.marketplaces_list);
                this.firstMarketplace = res?.data?.result?.marketplaces_list[0]?.id
            });
        },
        removeMarketplace(marketplace_id) {
            axios.post(`${this.url}/api/products/linked_product/detach-marketplace/${this.product}`,
            {
                marketplaces: [marketplace_id]
            }
            ).then(() => {
                    this.handleUpdateMarketplaces()
            });
        },
        getCatalogProductLink(linked_variant){
            let external_link= linked_variant[0]?.external_link;
            if (!external_link || external_link==""){
                external_link= this.product_link;
            }
            return external_link;
        }

    },
    mounted() {
        this.$i18n.locale = this.locale
        if (this.$i18n.locale == "en") {
            localStorage.setItem("lang", "en");
        } else {
            localStorage.setItem("lang", "ar");
        }

    },
}
</script>
